import Library from "../../../student/pages/Library/LibraryPage";
import StudentCamerasPage from "../../../student/pages/camerasPage/CamerasPage";
import Lessons from "../../../student/pages/lessonsPage/LessonsPage";

export const studentPanelRoutes = [
  {
    text: "Online Library",
    path: "/student-panel/library",
    exact: true,
    element: <Library />,
  },
  {
    text: "Students",
    path: "/student-panel/camera",
    exact: true,
    element: <StudentCamerasPage />,
  },
  {
    text: "student panel",
    path: "/student-panel/lessons",
    exact: true,
    element: <Lessons />,
  },
];
